"use strict";
const Snackbar_1 = require('material-ui/Snackbar');
const styles_1 = require('material-ui/styles');
const React = require('react');
const react_redux_1 = require('react-redux');
const sessions_1 = require('../actions/sessions');
const snackbarActions = require('../actions/snackbar');
const tasks_1 = require('../actions/tasks');
const actionTypes = require('../actionTypes');
const NoConnectionScreen_1 = require('./NoConnectionScreen');
const muiTheme_1 = require('./theme/muiTheme');
const SNACKBAR_AUTO_HIDE_DURATION = 4000;
const mapStateToProps = (state) => ({
    isOnline: state.connection.isOnline,
    isSnackbarOpen: state.snackbar.isOpen,
    snackbarMessage: state.snackbar.message,
    user: state.auth.user,
});
const mapDispatchToProps = (dispatch, state) => ({
    startListeningToTasks: (user) => dispatch(tasks_1.startListeningToTasks(user)),
    stopListeningToTasks: () => dispatch(tasks_1.stopListeningToTasks()),
    startListeningToSessions: (user) => dispatch(sessions_1.startListeningToSessions(user)),
    stopListeningToSessions: () => dispatch(sessions_1.stopListeningToSessions()),
    onSnackbarClose: () => dispatch(snackbarActions.dismissMessage()),
});
class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSnackbarOpen: this.props.isSnackbarOpen,
            wasEverOnline: this.props.isOnline,
        };
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.isOnline) {
            this.setState({ wasEverOnline: true });
        }
        if ((this.state.wasEverOnline || nextProps.isOnline) && nextProps.user && nextProps.user != this.props.user) {
            nextProps.startListeningToTasks(nextProps.user);
            nextProps.startListeningToSessions(nextProps.user);
        }
        this.setState({ isSnackbarOpen: nextProps.isSnackbarOpen });
    }
    componentWillUnmount() {
        this.props.stopListeningToTasks();
        this.props.stopListeningToSessions();
    }
    render() {
        return (React.createElement(styles_1.MuiThemeProvider, {muiTheme: muiTheme_1.default}, 
            React.createElement("div", null, 
                this.renderBody(), 
                this.renderSnackbar())
        ));
    }
    renderBody() {
        if (this.state.wasEverOnline) {
            return React.cloneElement(this.props.children, this.props);
        }
        else {
            return React.createElement(NoConnectionScreen_1.default, null);
        }
    }
    renderSnackbar() {
        let action, onActionTouchTap;
        let message = this.props.snackbarMessage;
        if (this.props.snackbarMessage === actionTypes.POST_SNACKBAR_APP_UPDATE_AVAILABLE) {
            action = 'Restart Now';
            message = 'A new version of My Minutes is available.';
            onActionTouchTap = () => window.location.reload();
        }
        return (React.createElement(Snackbar_1.default, {action: action, autoHideDuration: SNACKBAR_AUTO_HIDE_DURATION, message: message, open: this.state.isSnackbarOpen, onActionTouchTap: onActionTouchTap, onRequestClose: this.props.onSnackbarClose}));
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(App);



/** WEBPACK FOOTER **
 ** ./src/components/App.tsx
 **/